/**
 * Created by cevric on 09/06/2016.
 */

window.PurDocRow = {
    prepareFilterForm: function () {
        var options = {
            success: function (data) {
                PurDocRow.processFilterForm(data);
            }, dataType: "json"
        };
        MyForm.prepare("purdocrowsFilterForm", "purchases_purDocRows&action=updateListing", options);

    },
    processFilterForm: function(data){
        Listing.refresh("purdocrowsListing", data, data.purdocrows_metadatas);
    },
};
